import { Link } from '@mui/material'
import { useState } from 'react'
import reactStringReplace from 'react-string-replace'
import { RiskWarningIcon } from '../assets/icons'
import ZIcon from '../components/ZIcon'
import { RiskWarning } from '../types'
import ZButton from '../components/ZButton'
import ZText from '../components/ZText'
import ZBottomContainer from '../components/ZBottomContainer'
import ZScreenContainer from '../components/ZScreenContainer'
import Header from '../components/Header'

// Matches both the reqs wording ("Take 2 mins…") and the seeded prompt
// copy ("Take 2 minutes…") so the in-message phrase becomes the link.
const LEARN_MORE_PHRASE = /(Take 2 min(?:ute)?s to learn more)/

const RiskWarningForm = ({
  riskWarning,
  onDecision,
  loading,
}: {
  riskWarning: RiskWarning
  onDecision: (accepted: boolean, learnMoreViewedAt?: string) => void
  loading: boolean
}) => {
  const [learnMoreViewedAt, setLearnMoreViewedAt] = useState<string>()

  const learnMoreLink = (text: string, key: string) => (
    <Link
      key={key}
      href={riskWarning.learnMoreUrl}
      underline="always"
      target="_blank"
      onClick={() => setLearnMoreViewedAt(new Date().toISOString())}
    >
      {text}
    </Link>
  )

  const messageContainsPhrase = LEARN_MORE_PHRASE.test(riskWarning.message)

  return (
    <ZScreenContainer>
      <Header title="Risk Information" />

      <ZIcon
        Icon={RiskWarningIcon}
        title="Risk warning icon"
        style={{ alignSelf: 'center' }}
      />

      <ZText whiteSpace="pre-wrap">
        {messageContainsPhrase
          ? reactStringReplace(riskWarning.message, LEARN_MORE_PHRASE, match =>
              learnMoreLink(match, 'learn-more'),
            )
          : riskWarning.message}
        {!messageContainsPhrase ? (
          <>
            <br />
            <br />
            {learnMoreLink('Take 2 mins to learn more.', 'learn-more-fallback')}
          </>
        ) : null}
      </ZText>

      <ZBottomContainer>
        <ZButton
          onClick={() => onDecision(true, learnMoreViewedAt)}
          loading={loading}
        >
          Next
        </ZButton>

        <ZButton onClick={() => onDecision(false)} disabled={loading}>
          I wish to leave this investment journey
        </ZButton>
      </ZBottomContainer>
    </ZScreenContainer>
  )
}

export default RiskWarningForm
